import React, { Component } from "react";

class Captcha2026 extends Component {
  state = {
    mounted: false,
    activated: false,
  };

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({ mounted: true });
    }, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  handleClick = () => {
    this.setState({ activated: true });

    // Call the parent's function
    if (this.props.onActivate) {
      this.props.onActivate();
    }
  };

  render() {
    const { mounted, activated } = this.state;

    if (!mounted) {
      return (
        <div
          style={{ width: "200px", height: "35px", marginBottom: "5px", backgroundColor: "#eeeeee" }}
          aria-hidden="true"
        >
          &nbsp;
        </div>
      );
    }

    return (
      <div
        style={{
          width: "200px",
          height: "35px",
          marginBottom: "5px",
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
        }}
      >
        <label
          onClick={this.handleClick}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            userSelect: "none",
          }}
        >
          {activated ? (
            <input type="checkbox" checked readOnly />
          ) : (
            <span
              aria-hidden="true"
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid #ff0000",
                borderRadius: "2px",
                background: "#ffffff",
                display: "inline-block",
                boxSizing: "border-box",
              }}
            />
          )}

          <span>I am a human</span>
        </label>
      </div>
    );
  }
}

export default Captcha2026;
